import React from 'react'
import PropTypes from 'prop-types'
import InnerHTML from 'dangerously-set-html-content'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Flexlink from '../components/Flexlink'

const MenuContent = ({ title, subtitle, content }) => {

    const t = title

    const data = useStaticQuery(graphql`
      query Meals {
        allWpMeal(sort: {mealOptions: {sortOrder: ASC}}) {
          edges {
            node {
              uri
              slug
              title
              mealOptions {
                subtitle
                description
                menus {
                  ... on WpZMenu {
                    title
                  }
                }
              }
              featuredImage {
                node {
                  localFile {
                    url
                    publicURL
                  }
                }
              }
            }
          }
        }
      }
    `)

    console.log(subtitle)

    return (
      <React.Fragment>
        <h1 className='menu-title'>{t}</h1>
        <h4>{subtitle}</h4>

        <div className="yoast-breadcrumbs">
          <span>
            <span>
              <Link to="/">Home</Link> / 
              <span><Link to="/menus">Menus</Link> / 
                <span>
                  <Link to="/take-home-menu">Take Home Menu</Link>
                </span>
              </span>
            </span>
          </span>
        </div>

        <div className='page-content'>
          
          {content ? <InnerHTML html={content} /> : ''}

          <div className='grid tipped'>
            {data.allWpMeal.edges?.map(({ node }, index) => (
              node.mealOptions?.menus?.map(({ title }) =>
                t === title && (
                  <article key={`${title}-${index}`}>
                    <Flexlink to={node.uri}>
                      <img
                        src={node?.featuredImage?.node?.localFile?.url}
                        onError={(e) => (e.target.style.display = 'none')}
                        alt="meal"
                        className="grid-image"
                      />
                    </Flexlink>

                    <h5 className='grid-title'>
                      <Flexlink to={node.uri}>{node.title}</Flexlink>
                    </h5>
                    <p>{node.mealOptions.subtitle}</p>
                  </article>
                )
              ))
            )}
          </div>
        </div>
      </React.Fragment>
    )
}

MenuContent.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

export default MenuContent;